import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Button,
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Paper,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  TextareaAutosize,
  Box,
} from '@mui/material';
import {
  Receipt as ReceiptIcon,
  CalendarToday as CalendarTodayIcon,
  AttachMoney as AttachMoneyIcon,
  Person as PersonIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  CheckCircle as CheckCircleIcon,
  Refresh as RefreshIcon,
  Event as EventIcon,
  Schedule as ScheduleIcon,
} from '@mui/icons-material';
import {
  LocalizationProvider,
  DatePicker,
  TimePicker,
} from '@mui/x-date-pickers';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import {
  editarTarea,
  obtenerTareaPorId,
  obtenerTareasNotificacion,
} from '../../../actions/TareasAction';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import {
  obtenerFacturasCliente,
  obtenerPosiblesCobrosNotificacion,
  registrarPosibleCobro,
  modificarFactura,
  obtenerCobranzasNotificacion,
} from '../../../actions/CobranzasAction';
import ModalFacturasPC from './ModalFacturasPC';
import { useStateValue } from '../../../contexto/store';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';
export default function PanelGestionDePosiblesCobros(props) {
  const history = useHistory();
  const mounted = useRef(true);
  //eslint-disable-next-line
  const [{ openSnackBar, sesionUsuario }, dispatch] = useStateValue();
  const [fechaSeleccionada, setFechaSeleccionada] = useState(new Date());
  const [horaSeleccionadaHi, setHoraSeleccionadaHi] = useState(new Date());
  const usuarioAutorizado = props.location.state.user;
  const [DataPC, setDataPC] = useState(props.location.state);
  const [modalFacturasPC, setModalFacturasPC] = useState(false);
  const [facturasCliente, setFacturasCliente] = useState([]);
  const [tareaid, setTareaId] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [tareaNueva, setTareaNueva] = useState({
    TAREA_ID: '',
    CODTAREA: 0,
    USUARIOASIGNADO: '',
    CLIENTE_ID: '',
    FECHACREACION: '',
    FECHAVTO: '',
    TIPOTAREA: '',
    NUMTAREA: '',
    CLIENTE: '',
    CODPRESUPUESTO: '',
  });
  const [cierre, setCierre] = useState({
    MOTIVODECIERRE: 'Generacion de Posible Cobro',
  });
  const cerrarModal = () => {
    setModalFacturasPC(false);
  };
  const abrirModal = () => {
    setModalFacturasPC(true);
  };
  const dialogHandleOpen = () => {
    setOpenDialog(true);
  };
  //RR: CIERRA EL DIALOG DE MOTIVO DE CIERRE
  const dialogHandleClose = () => {
    setOpenDialog(false);
    setCierre({
      MOTIVODECIERRE: '',
    });
  };
  const cierreHandleChange = (e) => {
    const { name, value } = e.target;
    setCierre((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const eliminarFactura = (factura) => {
    setDataPC((facturaActual) =>
      facturaActual.filter((x) => x.nrocomprobante !== factura.nrocomprobante)
    );
  };
  const DevolverFacturas = () => {
    obtenerTareaPorId(props.location.state.tarea_id).then((response) => {
      if (response.status === 200) {
        setDataPC(response.data[0].facturas);
      }
    });
  };
  const seleccionarFactura = (factura) => {
    let comprobado = DataPC.find(
      (dato) => dato.nrocomprobante === factura.nrocomprobante
    );
    if (comprobado === undefined) {
      DataPC.push(factura);
      setModalFacturasPC(false);
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Esa factura ya esta cargada',
        },
      });
    }
  };
  const generarPosibleCobro = () => {
    let fechaposiblecobro =
      fechaSeleccionada.getFullYear() +
      '-' +
      (fechaSeleccionada.getMonth() + 1).toString().padStart(2, '0') +
      '-' +
      fechaSeleccionada.getDate().toString().padStart(2, '0') +
      'T' +
      horaSeleccionadaHi.getHours().toString().padStart(2, '0') +
      ':' +
      horaSeleccionadaHi.getMinutes().toString().padStart(2, '0') +
      ':00';
    /*RRR: se ectrae el dato necesario del array y se eliminan para su envio de forma optima al back*/
    delete DataPC['user'];
    delete DataPC['cliente_id'];
    delete DataPC['tarea_id'];
    let objeto = {
      FACTURAS: DataPC,
      posiblecobro: fechaposiblecobro,
      TAREAId: tareaid,
      posiblecobrogeneradopor: sesionUsuario.usuario.id,
    };
    if (usuarioAutorizado === 'COBRADOR') {
      objeto['pospuesto'] = moment().format();
    }
    registrarPosibleCobro(objeto).then((response) => {
      if (response.status === 200) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Se genero el posible Cobro el supervisor sera notificado',
          },
        });
        obtenerPosiblesCobrosNotificacion();
        dialogHandleOpen();
      } else {
        console.log('NO SE GENERO EL POSIBLE COBRO');
      }
    });
  };
  const marcarFacturaCobrada = (factura) => {
    setDataPC((facturaActual) =>
      facturaActual.filter((x) => x.nrocomprobante !== factura.nrocomprobante)
    );
    let objeto = {
      estado: 'PDB',
    };
    modificarFactura(factura.id, objeto).then((response) => {
      if (response.status === 200) {
        console.log('FACTURA CAMBIADA');
      }
    });
  };

  const cerrarTarea = (e) => {
    if (cierre.MOTIVODECIERRE !== '') {
      e.preventDefault();
      let fecha = moment().format().toString().substr(0, 16) + ':00';
      const id = tareaid;
      const objetoCierre = {
        COMPLETADO: fecha,
        MOTIVOCANCELACION: cierre.MOTIVODECIERRE,
      };
      editarTarea(id, objetoCierre).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se cerro exitosamente la Tarea',
            },
          });
          let objetoNoti = {
            USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
            UserName: sesionUsuario.usuario.userName,
          };
          obtenerTareasNotificacion(objetoNoti);
          obtenerCobranzasNotificacion(objetoNoti);
          setCierre({
            MOTIVODECIERRE: '',
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Modificacion',
            panel: 'Gestion de Tareas',
            tabla: 'TAREAS',
            filaafectada: props.location.state.clientE_Id,
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
          dialogHandleClose();
          props.history.go(-2);
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'DEBE AGREGAR UN MOTIVO DE CIERRE ',
        },
      });
    }
  };

  const cerrarTareaYNueva = (e) => {
    if (cierre.MOTIVODECIERRE !== '') {
      e.preventDefault();
      let fecha = moment().format().toString().substr(0, 16) + ':00';
      const id = tareaid;
      const objetoCierre = {
        COMPLETADO: fecha,
        MOTIVOCANCELACION: cierre.MOTIVODECIERRE,
      };
      editarTarea(id, objetoCierre).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se cerro exitosamente la Tarea',
            },
          });
          let objetoNoti = {
            USUARIOASIGNADO: sesionUsuario.usuario.nombrecompleto,
            UserName: sesionUsuario.usuario.userName,
          };
          obtenerTareasNotificacion(objetoNoti);
          obtenerCobranzasNotificacion(objetoNoti);
          setOpenDialog(false);
          setCierre({
            MOTIVODECIERRE: '',
          });
          tareaNueva['NTfacturas'] = true;
          tareaNueva['facturasNT'] = DataPC;
          dialogHandleClose();
          history.push({ pathname: '/nuevaTarea', state: tareaNueva });
        } else {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Errores al intentar guardar ',
            },
          });
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'DEBE AGREGAR UN MOTIVO DE CIERRE',
        },
      });
    }
  };
  useEffect(() => {
    if (mounted.current) {
      obtenerFacturasCliente(props.location.state.cliente_id).then(
        (response) => {
          if (response.status === 200) {
            setFacturasCliente(response.data);
          } else {
            console.log('NO TRAJO FACTURAS DE CLIENTE');
          }
        }
      );
      setTareaId(DataPC.tarea_id);
      setTareaNueva({
        TAREA_ID: '',
        CODTAREA: 0,
        USUARIOASIGNADO: '',
        CLIENTE_ID: DataPC.cliente_id,
        FECHACREACION: '',
        FECHAVTO: '',
        TIPOTAREA: '',
        NUMTAREA: '',
        CLIENTE: DataPC[0].cliente.nombre + ' ' + DataPC[0].cliente.apellido,
        CODPRESUPUESTO: '',
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [props, DataPC]);
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Paper
        elevation={0}
        sx={{
          background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
          borderRadius: 2,
          p: 3,
          mb: 3,
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            right: -20,
            top: -20,
            opacity: 0.2,
          }}
        >
          <ReceiptIcon sx={{ fontSize: 120, transform: 'rotate(-15deg)' }} />
        </Box>
        <Box sx={{ position: 'relative' }}>
          <Typography
            variant="h4"
            fontWeight={700}
            color="white"
            sx={{ display: 'flex', alignItems: 'center', gap: 2 }}
          >
            <ReceiptIcon sx={{ fontSize: 40 }} />
            {usuarioAutorizado === 'COBRADOR'
              ? 'Cobros a Posponer'
              : 'Generar Posible Cobro de Facturas'}
          </Typography>
        </Box>
      </Paper>

      {/* Table */}
      <Paper elevation={2} sx={{ borderRadius: 2, mb: 3, overflow: 'hidden' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ReceiptIcon sx={{ fontSize: 18 }} />
                    Factura
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <PersonIcon sx={{ fontSize: 18 }} />
                    Cliente
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CalendarTodayIcon sx={{ fontSize: 18 }} />
                    Fecha Factura
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <EventIcon sx={{ fontSize: 18 }} />
                    Fecha Vencimiento
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <AttachMoneyIcon sx={{ fontSize: 18 }} />
                    Saldo a Pagar
                  </Box>
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    backgroundColor: '#e3f2fd',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '0.875rem',
                    letterSpacing: '0.5px',
                    borderBottom: 2,
                    borderColor: 'primary.main',
                  }}
                >
                  {usuarioAutorizado === 'COBRADOR' ? 'Marcar Como' : 'Acciones'}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {DataPC.map((factura) => (
                <TableRow
                  key={factura.nrocomprobante}
                  sx={{
                    '&:hover': {
                      backgroundColor: '#f5f5f5',
                    },
                    '&:nth-of-type(even)': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <TableCell align="left">
                    <Typography variant="body2" fontWeight={600}>
                      {factura.nrocomprobante}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {factura.cliente.nombre + ' ' + factura.cliente.apellido}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {moment(factura.fechacomprobante).format('DD/MM/YYYY')}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {moment(factura.fechavencimiento).format('DD/MM/YYYY')}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="body2" fontWeight={600} color="error">
                      {Intl.NumberFormat('es').format(
                        factura.totalfactura - factura.montopagado
                      )}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    {usuarioAutorizado === 'COBRADOR' ? (
                      <Button
                        disabled={DataPC.length <= 1}
                        color="success"
                        variant="contained"
                        size="small"
                        startIcon={<CheckCircleIcon />}
                        onClick={() => marcarFacturaCobrada(factura)}
                        sx={{
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                        }}
                      >
                        Cobrado
                      </Button>
                    ) : (
                      <Button
                        disabled={DataPC.length <= 1}
                        color="error"
                        variant="outlined"
                        size="small"
                        startIcon={<DeleteIcon />}
                        onClick={() => eliminarFactura(factura)}
                        sx={{
                          borderRadius: 2,
                          textTransform: 'none',
                          fontWeight: 600,
                        }}
                      >
                        Eliminar
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* Action Buttons */}
      <Paper elevation={1} sx={{ p: 3, mb: 3, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 3 }}>
          <Button
            color="primary"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={DevolverFacturas}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Devolver Facturas al estado principal
          </Button>
          <Button
            color="primary"
            variant="contained"
            startIcon={<AddIcon />}
            onClick={abrirModal}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
            }}
          >
            Cargar más Facturas
          </Button>
        </Box>

        <Typography
          variant="h6"
          fontWeight={600}
          gutterBottom
          sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}
        >
          <EventIcon />
          {usuarioAutorizado !== 'COBRADOR'
            ? 'GENERAR NUEVO POSIBLE COBRO'
            : 'POSPONER COBRO'}
        </Typography>

        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
            gap: 3,
            mb: 3,
          }}
        >
          <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
            <DatePicker
              value={fechaSeleccionada}
              onChange={setFechaSeleccionada}
              label="Fecha de cobro Pactada"
              format="dd/MM/yyyy"
              slotProps={{
                textField: {
                  fullWidth: true,
                  InputProps: {
                    startAdornment: <CalendarTodayIcon sx={{ mr: 1, color: 'action.active' }} />,
                  },
                },
              }}
            />
          </LocalizationProvider>
          <LocalizationProvider locale={esLocale} utils={DateFnsUtils}>
            <TimePicker
              ampm={false}
              label="Hora pactada"
              value={horaSeleccionadaHi}
              onChange={setHoraSeleccionadaHi}
              slotProps={{
                textField: {
                  fullWidth: true,
                  InputProps: {
                    startAdornment: <ScheduleIcon sx={{ mr: 1, color: 'action.active' }} />,
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Box>

        <Button
          fullWidth
          onClick={generarPosibleCobro}
          variant="contained"
          color="primary"
          size="large"
          startIcon={usuarioAutorizado === 'COBRADOR' ? <ScheduleIcon /> : <CheckCircleIcon />}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.5,
          }}
        >
          {usuarioAutorizado === 'COBRADOR' ? 'Posponer' : 'Generar Posible Cobro'}
        </Button>
      </Paper>
      {/* Modal */}
      <ModalFacturasPC
        data={facturasCliente}
        open={modalFacturasPC}
        handleClose={cerrarModal}
        seleccionar={seleccionarFactura}
      />
      <div notranslate="true">
        <Dialog
          open={openDialog}
          onClose={dialogHandleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Alerta</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Debe agregar un motivo del cierre.
            </DialogContentText>
            <TextareaAutosize
              minRows={4}
              placeholder="Motivo de cierre"
              name="MOTIVODECIERRE"
              value={cierre.MOTIVODECIERRE}
              autoFocus
              onChange={cierreHandleChange}
              style={{
                width: '100%',
                padding: '12px',
                fontSize: '14px',
                borderRadius: '4px',
                border: '1px solid rgba(0, 0, 0, 0.23)',
                fontFamily: 'inherit',
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button
              variant="contained"
              onClick={cerrarTareaYNueva}
              color="primary"
            >
              Cerrar y Crear Nueva Tarea
            </Button>
            <Button variant="contained" onClick={cerrarTarea} color="primary">
              Solo Cerrar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </Container>
  );
}
